<template>
  <div
    id="VcHeader"
    :class="[$style.wrapper, { [$style.fullScreen]: isMenuOpen }]"
  >
    <header
      :class="[
        $style.header,
        { [$style.transparent]: isTransparent },
        { [$style.open]: isMenuOpen },
      ]"
    >
      <div ref="inner" :class="$style.inner">
        <ul :class="$style.left">
          <li>
            <button
              type="button"
              :class="[$style.icon, $style.menu, { [$style.open]: isMenuOpen }]"
              aria-controls="globalHeaderMenu"
              aria-label="メニュー"
              :aria-expanded="isMenuOpen.toString()"
              @click="onMenuClick"
            >
              <span />
              <span />
              <span />
              <span />
            </button>
          </li>
          <li>
            <a
              href="https://i-voce.jp/search/"
              class="icon-magnifyingglass"
              :class="[
                $style.icon,
                $style.search,
                { [$style.hidden]: isMenuOpen },
              ]"
            />
          </li>
          <li>
            <a
              :href="getCalendarLink"
              class="icon-calendar"
              :class="[
                $style.icon,
                $style.calendar,
                { [$style.hidden]: isMenuOpen },
              ]"
            />
          </li>
        </ul>
        <div :class="$style.center">
          <a href="https://i-voce.jp" :class="$style.logoWrapper">
            <VcLogo
              :class="$style.logo"
              :fill="isTransparent ? 'white' : 'black'"
            />
          </a>
          <div :class="$style.bestcosmeBnr">
            <a v-if="bestcosmeBanner.isDisplay" :href="bestcosmeBanner.url">
              <img
                :src="bestcosmeBanner.img"
                :alt="bestcosmeBanner.alt"
                :width="bestcosmeBanner.width"
                :height="bestcosmeBanner.height"
              />
            </a>
          </div>
        </div>
        <div :class="$style.right" />
      </div>
      <VcHeaderNavigation
        v-if="hasNavigation && !isMenuOpen"
        ref="navigation"
        :is-open="!isScrollingDown"
      />
    </header>
    <VcHeaderMenu
      id="globalHeaderMenu"
      :is-open="isMenuOpen"
      :top="headerHeight"
      @close="onMenuClose"
    />
  </div>
</template>

<script>
  import VcLogo from "./VcLogo.vue";
  import VcHeaderMenu from "./VcHeaderMenu.vue";
  import VcHeaderNavigation from "./VcHeaderNavigation.vue";

  let lastScrollTop = 0;

  export default {
    components: {
      VcLogo,
      VcHeaderMenu,
      VcHeaderNavigation,
    },
    props: {
      isTransparent: {
        type: Boolean,
        required: false,
        default: false,
      },
      hasNavigation: {
        type: Boolean,
        required: false,
        default: true,
      },
      background: {
        type: String,
        required: false,
        default: "#fff",
      },
    },
    data() {
      return {
        isMenuOpen: false,
        isMyMenuOpen: false,
        isNotificationOpen: false,
        headerHeight: 0,
        isScrollingDown: false,
        bestcosmeBanner: {
          img: require("@/assets/img/common/img_gnav_bestcosme_2025ss.jpg"),
          alt: "2025年上半期ベストコスメ",
          url: "https://i-voce.jp/bestcosme/",
          width: 225,
          height: 100,
          isDisplay: true,
        },
      };
    },
    computed: {
      getCalendarLink() {
        const YYYY = new Date().getFullYear();
        const MM = ("0" + (new Date().getMonth() + 1)).substr(-2);
        return `https://i-voce.jp/cosmetics/calendar/weekly/${YYYY}${MM}/`;
      },
    },
    mounted() {
      this.adjustLayout();

      window.addEventListener("resize", this.adjustLayout);
      window.addEventListener("scroll", this.onWindowScroll);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.adjustLayout);
      window.removeEventListener("scroll", this.onWindowScroll);
    },
    methods: {
      onMenuClick() {
        this.isMenuOpen = !this.isMenuOpen;
        if (this.isMenuOpen) {
          document.body.classList.add("g-no-scroll");
        } else {
          document.body.classList.remove("g-no-scroll");
        }
      },
      onMenuClose() {
        this.isMenuOpen = false;
        document.body.classList.remove("g-no-scroll");
      },
      onAvatarClick() {
        if (this.$store.state.community.isLoggedIn) {
          this.isMyMenuOpen = !this.isMyMenuOpen;
          document.body.classList.add("g-no-scroll");
        } else {
          this.$router.push("/login/");
        }
      },
      onMyMenuClose() {
        this.isMyMenuOpen = false;
        document.body.classList.remove("g-no-scroll");
      },
      onNotificationClose() {
        this.isNotificationOpen = false;
        this.$nextTick(this.adjustLayout);
      },
      adjustLayout() {
        const height = this.headerHeight;
        if (this.isNotificationOpen) {
          this.headerHeight =
            this.$refs.notification.$el.clientHeight +
            this.$refs.inner.clientHeight;
        } else {
          this.headerHeight = this.$refs.inner.clientHeight;
        }

        if (height !== this.headerHeight) {
          this.$emit("resize");
        }
      },
      onWindowScroll() {
        if (!this.hasNavigation) return;

        const top = window.pageYOffset || document.documentElement.scrollTop;
        this.isScrollingDown = top > lastScrollTop;
        document.documentElement.style.setProperty(
          "--header-nav-height-current",
          this.isScrollingDown ? "0px" : "var(--header-nav-height)"
        );
        lastScrollTop = top <= 0 ? 0 : top;
      },
    },
  };
</script>

<style lang="scss" module>
  .wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }
  .header {
    position: relative;
    background: #fff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 1px rgba(0, 0, 0, 0.08);
    z-index: 1;
  }
  .header li {
    list-style: none;
  }
  .transparent {
    background: rgba(254, 234, 230, 0.5);
    box-shadow: none;
    backdrop-filter: blur(12px);
  }
  .transparent .icon {
    color: rgba(17, 17, 17, 0.54);
  }
  .transparent .menu > span {
    background: rgba(17, 17, 17, 0.54);
  }
  .inner {
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 56px;
  }
  .left {
    display: flex;
    justify-content: flex-start;
  }
  .center {
    display: flex;
    justify-content: center;
  }
  .right {
    display: flex;
    justify-content: flex-end;
  }
  .bestcosmeBnr {
    min-width: 90px;
    margin: -5px 8px 0 8px;
    display: flex;
    align-items: center;
  }
  .bestcosmeBnr img {
    max-width: 90px;
    width: 100%;
    height: auto;
  }
  .logo {
    width: 69px;
    height: 33px;
  }
  .icon {
    position: relative;
    display: block;
    margin: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: rgba(17, 17, 17, 0.8);
    font-size: 30px;
    text-align: center;
    opacity: 1;
    transition: all 0.2s;

    &[class] {
      line-height: 40px;
    }
  }
  .icon:active {
    background-color: rgba(0, 0, 0, 0.2);
  }
  .hidden {
    opacity: 0;
    pointer-events: none;
  }
  .menu > span {
    display: block;
    position: absolute;
    left: 10px;
    height: 2px;
    width: 20px;
    background: rgba(17, 17, 17, 0.8);
    border-radius: 2px;
    opacity: 1;
    transform: rotate(0deg);
    transition: 0.2s ease-out;
  }
  .menu > span:nth-child(1) {
    top: 13px;
  }
  .menu > span:nth-child(2),
  .menu > span:nth-child(3) {
    top: 20px;
  }
  .menu > span:nth-child(4) {
    top: 27px;
  }
  .menu.open > span:nth-child(1) {
    top: 20px;
    width: 0%;
    left: 50%;
  }
  .menu.open > span:nth-child(2) {
    transform: rotate(45deg);
  }
  .menu.open > span:nth-child(3) {
    transform: rotate(-45deg);
  }
  .menu.open > span:nth-child(4) {
    top: 20px;
    width: 0%;
    left: 50%;
  }

  @media screen and (min-width: 769px) {
    .inner {
      padding: 0 16px;
      height: 72px;
    }
    .header.open .inner {
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06),
        0px 1px 1px rgba(0, 0, 0, 0.08);
    }
    .header.open {
      z-index: 3;
    }
    .header.open .navigation {
      display: none;
    }
    .right,
    .left {
      flex-basis: 33.33%;
      flex-shrink: 2;
    }
    .logo {
      width: 94px;
      height: 45px;
    }
    .icon {
      margin: 0 8px;
    }
    .bestcosmeBnr {
      width: 113px;
      margin: -5px -128px 0 15px;
    }
    .bestcosmeBnr img {
      max-width: inherit;
      height: 50px;
      width: 113px;
    }
  }
  :root {
    --header-height: 72px;
    --header-nav-height: 32px;
    --header-nav-height-current: var(--header-nav-height);

    @media (max-width: 768px) {
      --header-height: 56px;
    }
  }
</style>
